import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../components/messaging/cp-message-history.js';
import '../components/shared/cp-page-subnav.js';

const COMM_TABS = [
  { label: 'CEO Chats', path: '/ceo-chats' },
  { label: 'Nachrichten', path: '/messages' },
  { label: 'Inbox', path: '/inbox' },
  { label: 'Kontakte', path: '/people' },
];

@customElement('cp-page-messages')
export class CpPageMessages extends LitElement {
  createRenderRoot() { return this; }

  render() {
    return html`
      <div class="cp-page cp-page-messages">
        <cp-page-subnav .tabs=${COMM_TABS} activePath="/messages"></cp-page-subnav>
        <h1 class="cp-page__title">Nachrichten</h1>
        <cp-message-history></cp-message-history>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-messages': CpPageMessages;
  }
}
